/**
 * notification_preview_controller.js — starts the bell on the notification
 * preview page (templates/notification_preview.html).
 *
 * In the app, notification-ui.js starts each bell on turbo:load. The preview
 * page is a standalone document without Turbo, so this controller makes the one
 * init() call that turbo:load would have made. Everything after that (fetching
 * the draft from the bell's data-notif-api, the badge, the dropdown, following
 * the link) is notification-ui.js unchanged, which is what makes the preview
 * show the real thing. init() is idempotent, so a reconnect is harmless.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        if (window.NotificationUI) window.NotificationUI.init();
    }
}
